import { defineClassNames } from '../../utils/defineClassNames';

export const classes = defineClassNames('segmented-toggle-button', {
  root: {
    variants: {
      size: ['tiny', 'small', 'medium'],
    },
    states: ['selected', 'disabled'],
  },
  label: {},
  prefix: {},
});
